var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.934 8.246v3.791a2.31 2.31 0 01-2.317 2.317H3.192a2.31 2.31 0 01-2.317-2.317v-3.79h13.06zM9.09 9.721a.62.62 0 00-.632.632v.42H6.35v-.42a.62.62 0 00-.631-.632.62.62 0 00-.632.632v.631c0 .59.463 1.053 1.053 1.053h2.527c.59 0 1.054-.463 1.054-1.053v-.631a.62.62 0 00-.632-.632zM11.617.875a2.31 2.31 0 012.317 2.317v3.79H.875v-3.79A2.31 2.31 0 013.192.875zM9.09 2.981a.62.62 0 00-.632.632v.421H6.35v-.421a.62.62 0 00-.631-.632.62.62 0 00-.632.632v.632c0 .59.463 1.053 1.053 1.053h2.527c.59 0 1.054-.463 1.054-1.053v-.632a.62.62 0 00-.632-.632z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default ForwardRef;